import React, { useState } from "react";
import axios from "axios";
import {
  Box,
  TextField,
  Button,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormHelperText,
  Snackbar,
  Alert,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  send_otp,
  validate_otp,
  user_signup,
} from "../Api service/APIvariables";
import { useNavigate } from "react-router-dom";
import Countdown from "react-countdown";
import productsImage from "../assets/products.png";
import OTP from "./OTP"; // Import your OTP component here
import { toast } from "react-toastify";
import mdqLogo from "../assets/mdqlogo.jpeg";
import SnackBar from "./SnackBar";

export default function SignUp() {
  const [fullName, setFullName] = useState("");
  // const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [otpValidated, setOtpValidated] = useState(false);
  const [passwordStrengthText, setPasswordStrengthText] = useState("");
  const [isPasswordTouched, setIsPasswordTouched] = useState(false);
  const [timerKey, setTimerKey] = useState(0);
  const [isTimerEnded, setIsTimerEnded] = useState(false);

  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState(false);
  const [color, setColor] = useState(false); // Default Snackbar color
  const [message, setMessage] = useState("");

  const navigate = useNavigate();

  const handleSendOtp = async () => {
    if (!fullName || !email || !mobile || !companyName) {
      setMessage("Name, Email, Mobile, and Company Name are required.");
      setOpen(true);
      setStatus(false);
      setColor(false);
      return;
    }
    const regex =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA0-9]{2,}(?:\.[a-zA-Z]{2,})?$/;
    if (!regex.test(email)) {
      setMessage("Please enter a valid email address.");
      setOpen(true);
      setStatus(false);
      setColor(false);
      return;
    }
    setIsLoading(true);

    try {
      const formData = new FormData();
      formData.append("email", email);

      const response = await axios.post(send_otp, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200) {
        setMessage(`OTP sent successfully to ${email}`);
        setOtpSent(true);
        setColor(true);
        setStatus(true);
        setTimerKey((prevKey) => prevKey + 1); // Increment timer key to reset countdown
      } else {
        setMessage("Failed to send OTP.");
        setOpen(true);
        setColor(false);
        setStatus(false);
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      setMessage("Failed to send OTP. Please try again.");
      setColor(false);
      setStatus(false);
      setOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleValidateOtp = async () => {
    if (!otp || !email) {
      setMessage("Please enter OTP and email.");
      setColor(false);
      setColor(false);
      setOpen(true);
      return;
    }

    setIsLoading(true);

    try {
      const formData = new FormData();
      formData.append("email", email);
      formData.append("otp", otp);

      const { data } = await axios.post(validate_otp, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log(data);

      if (!data.error) {
        setMessage("OTP validated successfully!");
        setOpen(true);
        setColor(true);
        setStatus(true);
        // toast.success(data.message);
        // alert("OTP validated successfully!");
        setOtpValidated(true);
      } else {
        setOtpValidated(false);
        // toast.error(data.message);
        setMessage(data.data.message || "Invalid OTP or validation failed.");
        setColor(false);
        setStatus(false);
        setOpen(true);
      }
    } catch (error) {
      console.error("Error validating OTP:", error);
      setMessage("OTP validation failed. Please try again.");
      setColor(false);
      setStatus(false);
      setOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const submit = async () => {
    if (password === confirmPassword) {
      const formData = new FormData();
      formData.append("fullName", fullName);
      formData.append("email", email);
      formData.append("password", password);
      formData.append("mobile", mobile);
      formData.append("company_name", companyName);

      try {
        const response = await axios.post(user_signup, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (response.data.error) {
          setMessage(response.data.message);
          setColor(false);
          setStatus(false);
          setOpen(true);
        } else {
          setMessage(response.data.message);
          setColor(true);
          setStatus(true);
          setOpen(true);

          // Store user data in localStorage
          localStorage.setItem("fullname", fullName);
          localStorage.setItem("email", email);
          localStorage.setItem("Userauth", true);
          localStorage.setItem("userId", response.data.userId);
          navigate("/login");

          // Clear form data after successful signup
          setEmail("");
          setFullName("");
          setMobile("");
          setCompanyName("");
          setPassword("");
          setConfirmPassword("");
        }
      } catch (error) {
        console.error("Error during signup:", error);
        alert("Signup failed. Please try again.");
      }
    } else {
      alert("Error: Passwords do not match.");
    }
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => event.preventDefault();

  const handlePasswordChange = (event) => {
    const passwordValue = event.target.value;
    setPassword(passwordValue);

    if (isPasswordTouched) {
      validatePasswordStrength(passwordValue);
    }
  };

  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
  };

  const validatePasswordStrength = (password) => {
    const length = password.length;
    if (length < 6) {
      setPasswordStrengthText("Password is too weak");
    } else if (length < 8) {
      setPasswordStrengthText("Password is medium strength");
    } else {
      setPasswordStrengthText("Password is strong");
    }
  };

  const handlePasswordFocus = () => {
    setIsPasswordTouched(true);
    validatePasswordStrength(password);
  };

  function SignInLink() {
    const navigate = useNavigate();
    return (
      <Button
        variant="text"
        sx={{ textTransform: "none", marginTop: 2 }}
        onClick={() => navigate("/login")}
        style={{
          alignItems: "center",
          justifyContent: "center",
          paddingRight: "10px",
        }}
      >
        Already have an account? Sign In
      </Button>
    );
  }

  // Timer renderer for Countdown component
  const countdownRenderer = ({ minutes, seconds, completed }) => {
    if (completed) {
      setIsTimerEnded(true); // Set timer ended state when countdown completes
      return null; // Hide the timer when it's done
    }
    return (
      <Typography>
        {minutes < 10 ? `0${minutes}` : minutes}:
        {seconds < 10 ? `0${seconds}` : seconds}
      </Typography>
    );
  };

  const handleResendOtp = () => {
    setOtpSent(false); // Reset OTP sent status
    setOtp(""); // Clear the OTP field
    setTimerKey((prevKey) => prevKey + 1); // Reset the timer
    setIsTimerEnded(false); // Reset timer state
    handleSendOtp(); // Send the OTP again
  };

  return (
    <div
      className="sign-up"
      style={{ backgroundColor: "#eaf4fc", height: "100vh" }}
    >
      {/* <SnackBar
        open={open}
        message={message}
        setOpen={setOpen}
        status={status}
        color={color}
      /> */}
      <Snackbar
        open={open}
        autoHideDuration={4000}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setOpen(false)}
          severity={status ? "success" : "error"}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
      <Box sx={{ px: 2 }}>
        <Grid container sx={{ height: "100vh" }} alignItems={"center"}>
          {/* Left Column : Image */}
          <Grid
            item
            xs={0}
            md={6}
            sx={{
              display: { xs: "none", md: "flex" },
              justifyContent: "center",
              alignItems: "center",
              padding: 2,
            }}
          >
            <Box
              sx={{
                height: "100%",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 2,
              }}
            >
              <img
                src={productsImage}
                alt="Product Image"
                style={{
                  maxWidth: "80%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
              />
            </Box>
          </Grid>

          {/* Right Column: Sign-up Form */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: { xs: "auto", sm: "80vh", md: "auto" },
                px: { xs: 2, sm: 4, md: 5 },
                padding: "20px",
                width: { xs: "90%", sm: "80%", md: "70%" },
                mx: "auto",
              }}
            >
              <Box
                sx={{
                  border: "1px solid #eaf4fc",
                  borderRadius: "15px",
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "white",
                  padding: 4,
                  width: "100%", // Ensures box occupies the full width of the grid container
                  maxWidth: 500, // Optional: limits box width
                  boxSizing: "border-box", // Ensures padding is included in the width calculation
                }}
              >
                <img
                  src={mdqLogo}
                  alt="MDQ Logo"
                  style={{
                    display: "block",
                    height: "45%",
                    width: "45%",
                    // marginBottom: "20px",
                    justifyContent: "center",
                    alignItems: "center",
                    alignContent: "center",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                />
                <Typography
                  variant="h5"
                  fontSize={{ xs: 18, sm: 20, md: 24 }}
                  sx={{
                    textAlign: "center",
                    fontWeight: 600,
                    color: "#52459f",
                    mt: 1,
                  }}
                >
                  Sign Up & Get Started Today
                </Typography>

                {/* Name and Email Fields */}
                {!otpSent && !otpValidated && (
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        label="Full Name*"
                        variant="outlined"
                        fullWidth
                        value={fullName}
                        onChange={(e) => setFullName(e.target.value)}
                        sx={{
                          marginTop: 1,
                          // backgroundColor: "#",
                        }}
                        InputProps={{
                          sx: {
                            // height: "40px", // Ensure consistent height
                            // padding: "0 14px", // Padding for the input text
                            borderRadius: "6px",
                            // height: { xs: 40, sm: 45, md: 50 },
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#eaf4fc",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#eaf4fc",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#eaf4fc",
                            },
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            fontSize: "14px", // Adjust font size for label
                            transform: "translate(14px, 12px) scale(1)", // Default position
                            "&.MuiInputLabel-shrink": {
                              transform: "translate(14px, -5px) scale(0.75)", // Adjusted for focused/shrink state
                            },
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                )}

                {/* <Grid container spacing={2}> */}
                {/* Email Address Field */}
                {!otpSent && !otpValidated && (
                  <Grid item xs={12}>
                    <TextField
                      label="Email*"
                      variant="outlined"
                      fullWidth
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      sx={{
                        marginTop: 1,
                      }}
                      InputProps={{
                        sx: {
                          // height: "40px", // Ensure consistent height
                          // padding: "0 14px", // Padding for the input text
                          borderRadius: "6px",
                          // height: { xs: 40, sm: 45, md: 50 },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#eaf4fc",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#eaf4fc",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#eaf4fc",
                          },
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          fontSize: "14px", // Adjust font size for label
                          transform: "translate(14px, 12px) scale(1)", // Default position
                          "&.MuiInputLabel-shrink": {
                            transform: "translate(14px, -5px) scale(0.75)", // Adjusted for focused/shrink state
                          },
                        },
                      }}
                    />
                  </Grid>
                )}

                {/* Mobile Field */}
                {!otpSent && !otpValidated && (
                  <Grid item xs={12}>
                    <TextField
                      label="Mobile*"
                      variant="outlined"
                      fullWidth
                      value={mobile}
                      onChange={(e) => setMobile(e.target.value)}
                      sx={{
                        marginTop: 1,
                      }}
                      InputProps={{
                        sx: {
                          borderRadius: "6px",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#eaf4fc",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#eaf4fc",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#eaf4fc",
                          },
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          fontSize: "14px",
                          transform: "translate(14px, 12px) scale(1)",
                          "&.MuiInputLabel-shrink": {
                            transform: "translate(14px, -5px) scale(0.75)",
                          },
                        },
                      }}
                    />
                  </Grid>
                )}

                {/* Company Name Field */}
                {!otpSent && !otpValidated && (
                  <Grid item xs={12}>
                    <TextField
                      label="Company Name*"
                      variant="outlined"
                      fullWidth
                      value={companyName}
                      onChange={(e) => setCompanyName(e.target.value)}
                      sx={{
                        marginTop: 1,
                      }}
                      InputProps={{
                        sx: {
                          borderRadius: "6px",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#eaf4fc",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#eaf4fc",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#eaf4fc",
                          },
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          fontSize: "14px",
                          transform: "translate(14px, 12px) scale(1)",
                          "&.MuiInputLabel-shrink": {
                            transform: "translate(14px, -5px) scale(0.75)",
                          },
                        },
                      }}
                    />
                  </Grid>
                )}

                {/* Send OTP Button */}
                {!otpSent && !otpValidated && (
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      fullWidth
                      disabled={isLoading}
                      onClick={handleSendOtp}
                      sx={{
                        // height: "40px", // Adjust button height
                        marginTop: 3, // Align with the email field
                        backgroundColor: "#52459f",
                        "&:hover": { backgroundColor: "#41378e" },
                      }}
                    >
                      {isLoading ? "Sending..." : "Send OTP"}
                    </Button>
                  </Grid>
                )}

                {/* Log In Link */}
                {!otpSent && !otpValidated && (
                  <Grid item xs={12} sx={{ textAlign: "center", mt: 1 }}>
                    <SignInLink />
                  </Grid>
                )}

                {/* OTP Input */}
                {otpSent && !otpValidated && (
                  <Grid container spacing={2} sx={{ marginTop: 1 }}>
                    <Grid item xs={12}>
                      <TextField
                        label="Enter OTP"
                        fullWidth
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        sx={{
                          // marginTop: "10px", // Align with other fields
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#eaf4fc", // Default border color
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#eaf4fc", // Same border color on hover
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#eaf4fc", // Focused border color
                          },
                        }}
                        inputProps={{
                          maxLength: 6, // Limit OTP length to 6 digits
                        }}
                      />
                    </Grid>
                  </Grid>
                )}
                {/* Timer and Resend OTP Below Email */}
                {otpSent && !otpValidated && (
                  <Grid
                    container
                    spacing={2}
                    sx={{ justifyContent: "flex-end", marginTop: 1 }}
                  >
                    <Grid
                      item
                      xs={4}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        // fontSize: "20px",
                      }}
                    >
                      {!isTimerEnded && (
                        <Countdown
                          key={timerKey}
                          date={Date.now() + 120000} // 2 minutes timer (120,000 ms)
                          renderer={countdownRenderer}
                          onComplete={() => setIsTimerEnded(true)}
                        />
                      )}
                    </Grid>
                    <Grid
                      item
                      xs={8}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        right: 0,
                        ml: 2,
                      }}
                    >
                      {isTimerEnded && (
                        <Button
                          variant="text"
                          onClick={handleResendOtp}
                          sx={{
                            textTransform: "none",
                            color: "#52459f",
                            "&:hover": { backgroundColor: "#f2f2f2" },
                          }}
                        >
                          Resend OTP
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                )}

                {/* OTP Validation Button */}
                {otpSent && !otpValidated && (
                  <Button
                    variant="contained"
                    disabled={isLoading}
                    sx={{
                      width: "100%",
                      height: "40px", // Adjust height of button
                      marginTop: 1,
                      padding: "6px",
                      backgroundColor: "#52459f",
                      "&:hover": { backgroundColor: "#41378e" },
                    }}
                    onClick={handleValidateOtp}
                  >
                    {isLoading ? "Validating..." : "Validate OTP"}
                  </Button>
                )}

                {/* Password & Confirm Password */}
                {otpValidated && (
                  <>
                    <FormControl fullWidth margin="normal">
                      <InputLabel
                        htmlFor="password"
                        sx={{
                          fontSize: "14px", // Adjust label font size
                          marginTop: "16px",
                          transform: "translate(14px, 12px) scale(1)", // Default position
                          "&.MuiInputLabel-shrink": {
                            transform: "translate(14px, -5px) scale(0.75)", // Shrink state
                          },
                        }}
                      >
                        Password *
                      </InputLabel>
                      <OutlinedInput
                        id="password"
                        type={showPassword ? "text" : "password"}
                        value={password}
                        onChange={handlePasswordChange}
                        onFocus={handlePasswordFocus}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                            >
                              {showPassword ? (
                                <Visibility
                                  sx={{ paddingTop: "4px", marginTop: "7px" }}
                                />
                              ) : (
                                <VisibilityOff
                                  sx={{ paddingTop: "4px", marginTop: "7px" }}
                                />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                        sx={
                          {
                            // height: "40px", // Adjust height
                            // padding: "0 14px", // Padding for input text
                          }
                        }
                        label="Password"
                      />
                      {password && isPasswordTouched && (
                        <FormHelperText>{passwordStrengthText}</FormHelperText>
                      )}
                    </FormControl>

                    <FormControl fullWidth margin="normal">
                      <InputLabel
                        htmlFor="confirm-password"
                        sx={{
                          fontSize: "14px", // Adjust label font size,
                          marginTop: "16px",
                          // top: -2,
                          // textAlign: "center",
                          transform: "translate(14px, 12px) scale(1)", // Default position
                          "&.MuiInputLabel-shrink": {
                            transform: "translate(14px, -5px) scale(0.75)", // Shrink state
                          },
                        }}
                      >
                        Confirm Password *
                      </InputLabel>
                      <OutlinedInput
                        id="confirm-password"
                        type={showPassword ? "text" : "password"}
                        value={confirmPassword}
                        onChange={handleConfirmPasswordChange}
                        sx={
                          {
                            // height: "40px", // Adjust height
                            // padding: "0 14px", // Padding for input text
                            // marginBottom: 2,
                          }
                        }
                        label="Confirm Password"
                      />
                    </FormControl>

                    {/* Submit Button */}
                    <Button
                      variant="contained"
                      onClick={submit}
                      sx={{
                        width: "100%",
                        height: "40px", // Adjust height of button
                        marginTop: 5,
                        backgroundColor: "#52459f",
                        "&:hover": { backgroundColor: "#41378e" },
                      }}
                    >
                      Sign Up
                    </Button>
                  </>
                )}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
